import { useState } from "react";
import { faqs } from "@/mocks/dramaData";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.6fr]">
          <div>
            <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-800">
              <i className="ri-question-line"></i> 吃瓜指南
            </span>
            <h2 className="font-heading text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
              关于本月大瓜
              <br />
              你可能想问的
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              榜单规则、筛选逻辑、内容来源，这里都讲清楚。还有疑问欢迎通过下方投稿表单或邮箱联系我们。
            </p>
            <a
              href="#contact"
              className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-foreground-800"
            >
              联系我们
              <i className="ri-mail-line"></i>
            </a>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((f, i) => {
              const open = openIndex === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-2xl border transition ${
                    open ? "border-primary-200 bg-background-50" : "border-background-200 bg-background-50"
                  }`}
                >
                  <button
                    onClick={() => setOpenIndex(open ? -1 : i)}
                    className="flex w-full cursor-pointer items-center justify-between gap-3 px-5 py-4 text-left md:px-6"
                    aria-expanded={open}
                  >
                    <span className="text-sm font-bold text-foreground-950 md:text-base">{f.q}</span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition ${
                        open ? "bg-primary-500 text-background-50 rotate-180" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </button>
                  <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}